import React from "react";
import { Skeleton } from 'primereact/skeleton';


const UserProfileSkeleton = () => {
    return(
        <>
            <div className="edit-profile-page">
                <div className="p-card">
                    <div className="flex flex-column">
                    <div className="flex flex-row justify-content-between">
                        <Skeleton width="10rem" className="mb-2"></Skeleton>
                        <Skeleton width="5rem" className="mb-2"></Skeleton>
                    </div>
                    <div className="mt-2">
                        <Skeleton width="100%" height="150px"></Skeleton>
                    </div>
                    <div className="flex flex-column justify-content-evenly mt-5">
                        <div className="flex flex-row justify-content-between mb-2">
                            <Skeleton shape="rectangle" height="2rem" width="17rem" className="mb-2 mr-2" />
                            <Skeleton shape="rectangle" height="2rem" width="17rem" className="mb-2 mr-2" />
                            <Skeleton shape="rectangle" height="2rem" width="17rem" className="mb-2 mr-2" />
                            <Skeleton shape="rectangle" height="2rem" width="17rem" className="mb-2 mr-2" />
                            <Skeleton shape="rectangle" height="2rem" width="17rem" className="mb-2 mr-1" />
                        </div>               
                        <div className="flex flex-row justify-content-between mb-2">
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-1" />
                        </div>
                        <div className="flex flex-row justify-content-between mb-2">
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-1" />
                        </div> 
                        <div className="flex flex-row justify-content-between mb-2">
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-1" />
                        </div> 
                        <div className="flex flex-row justify-content-between mb-2">
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-1" />
                        </div> 
                        <div className="flex flex-row justify-content-between mb-2">
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-2" />
                            <Skeleton width="17rem" className="mb-2 mr-1" />
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserProfileSkeleton;